import { styled } from '@mui/material/styles';
import { Box, Typography, IconButton, Button } from '@mui/material';

export const BackButton = styled(Box)(({ theme }) => ({
  color: theme.palette.common.white,
  marginLeft: '39px',
}));

export const TimeText = styled(Typography)({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '22px',
  marginBottom: '10px',
});

export const Instruction = styled(Typography)(({ theme }) => ({
  marginTop: '4px',
  marginBottom: '0px',
  color: theme.palette.common.white,
  fontWeight: 600,
  fontSize: '17px',
  lineHeight: '24px',
}));

export const PreviewWrapper = styled(Box)({
  position: 'relative',
  height: 'var(--app-height)',
  minHeight: '550px',
  background: '#000001',
});

export const PreviewControlsWrapper = styled(Box)({
  position: 'absolute',
  bottom: '0',
  height: '100px',
  width: 'calc(100% + 2px)',
  left: '-1px',
  background: 'rgba(0, 0, 0, 0.70)',
  zIndex: 20,
});

export const ButtonsWrapper = styled(Box)({
  justifyContent: 'space-between',
  alignItems: 'center',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
});

export const GetReadyText = styled(Typography)({
  textAlign: 'center',
  lineHeight: '150%',
  padding: '3px 0',
  fontSize: 'clamp(14px, 4vw, 17px )',
});

export const RecordText = styled(Typography)({
  fontWeight: 600,
  lineHeight: '150%',
  textAlign: 'center',
  padding: '3px 0',
});

export const RecordCounter = styled(Box)({
  position: 'absolute',
  width: '100%',
  height: '100%',
  zIndex: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '150px',
  textShadow: '0px 0px 14px rgba(0, 0, 0, 0.35)',
  fontFamily: 'Poppins',
});

export const VideoPreview = styled('video')({
  position: 'absolute',
  width: '100%',
  height: '100%',
  aspectRatio: '9 / 16',
  top: 0,
  cursor: 'pointer',
});

export const PlayIcon = styled(IconButton)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, calc(-50% - 50px))',
  cursor: 'pointer',
  zIndex: 30,
});

export const VideoPreviewWrapper = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '100%',
});

export const LogoOverlay = styled(Box)({
  cursor: 'pointer',
  position: 'absolute',
});

export const SubmitVideoText = styled(Typography)({
  fontWeight: 600,
  lineHeight: '150%',
  textAlign: 'center',
  padding: '3px 0',
});

export const SubmitControlsWrapper = styled(Box)({
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 20px',
});

export const RetakeButton = styled(Button)({
  color: '#fff',
  border: '1px solid white',
  borderRadius: '60px',
  padding: '14px 24px',
});

export const SubmitButton = styled(Button)({
  borderRadius: '60px',
  padding: '14px 24px',
  backgroundColor: '#2D11AD',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#2D11AD',
  },
});

